import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import Skeleton from 'react-loading-skeleton';

import styled from 'styled-components';

const Card = styled.button`
	padding: 0;
	margin: 0;
	border: solid 1px transparent;
	text-align: left;
	cursor: pointer;
	display: flex;
	border-radius: 3px;
	background-color: #FFF;

	& > div {
		display: flex;
		flex-direction: column;
	}
`;

const CardInnerWrapper = styled.div`
	width: 100%;
	height: 100%;
`;

const CardTitle = styled.h4`
	line-height: 21px;
	font-size: 18px;
	font-weight: 500;
	margin: 0;
	padding: 20px 25px;
	border-bottom: solid 1px #DDDFE2;
	color: #2979FF;
`;

const CardContent = styled.p`
	flex-grow: 1;
	padding: 17px 25px 10px 25px;
	margin: 0;
	line-height: 19px;
	font-size: 16px;
`;

const CardActions = styled.div`
	line-height: 1.2em;
	padding: 24px 25px;
	margin-top: auto;
	text-align: right;
`;

const CardAction = styled.div`
	display: inline-block;
	line-height: 2em;
	padding: 5px 26px;
	font-size: 13px;
	font-weight: 500;
	background-color: #2979FF;
	border-radius: 50px;
	color: #FFF;
	cursor: pointer;
	transition: 200ms ease-in;

	&:hover {
		opacity: 0.9;
	}
`;

const CustomCard = ({
	loading,
	title,
	description,
	target,
	targetLabel
}) => {

	const history = useHistory();

	const goToTarget = useCallback(() => {

		if(!target)
			return;

		history.push(target);

	}, [history, target]);

	return (
		<Card onClick={goToTarget}>
			<CardInnerWrapper>
				<CardTitle>{loading ? <Skeleton/> : title}</CardTitle>
				<CardContent>{loading ? <Skeleton/> : description || '\u00A0'}</CardContent>
				<CardActions>
					{
						loading
							? <Skeleton width={90} height={40} />
							: <CardAction>{targetLabel}</CardAction>
					}
				</CardActions>
			</CardInnerWrapper>
		</Card>
	);

};

export default CustomCard;